import React from 'react';

import './PomoSettings.css';
import xIcon from './xIcon.png';
import NumberSwiper from './NumberSwiper';
import { Link } from "@reach/router"

class PomoSettings extends React.Component {

	
	render() {
		return (
			<div className='pomo-settings-box' >
				<div className='top-box' >
					<Link to='/'>
						<img className='exit-more-icon grow' src={xIcon} alt='icon' />
					</Link>
				</div>
				<section className='pomo-settings-timer'>
					<h2 className='pomo-settings-header'>Timer</h2>	
					<div className='work-settings'>
						<div className='pomo-settings-sub-header'>
							<h3>Work Interval</h3>
							<h3>Minutes</h3>
						</div>
						<NumberSwiper sessionTime={this.props.workTime} handleSessionTime={this.props.handleWorkTime} handleCurrentTime={this.props.handleCurrentTime} swiperContainer='swiper-container-work' />		
					</div>
					<div className='work-settings'>
						<div className='pomo-settings-sub-header'>
							<h3>Break Interval</h3>
							<h3>Mintues</h3>
						</div>
						<NumberSwiper sessionTime={this.props.breakTime} handleSessionTime={this.props.handleBreakTime} handleCurrentTime={this.props.handleCurrentTime} swiperContainer='swiper-container-break'/>	

					</div>
				</section>
				<section className='pomo-settings-stats'>
					<h2 className='pomo-settings-header'>Stats</h2>	
				</section>
			</div>
		);	
	}
	
}

export default PomoSettings;
